<template>
  <a-modal width="60%" :label-col="4" :wrapper-col="14" :visible="open" @ok="onOk" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>Select Products</b>
    </a-divider>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('商品类型')" prop="goodsType">
                <a-select   :placeholder="$t('请选择')+$t('商品类型')" style="width: 100%" v-model="queryParam.goodsType" allowClear>
                  <a-select-option v-for="(item, index) in goodsTypeOption" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="规格编码" prop="id">
                <a-input v-model="queryParam.id" :maxLength="20" :placeholder="$t('请输入')+'规格编码'" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="规格名称" prop="goodsArchiveName">
                <a-input v-model="queryParam.goodsArchiveName" :maxLength="16" :placeholder="$t('请输入')+$t('商品名称')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6 || 24" :sm="24">
                <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                  <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                  <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
                </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div style="margin-bottom: 16px">
        <a-button type="primary" :disabled="this.selectedRowKeys.length <= 0" :loading="loading" @click="reload">
          取消全部
        </a-button>
        <span style="margin-left: 8px">
        <template v-if="this.selectedRowKeys.length > 0">
          {{ `已选择数量: ${selectedRowKeys.length} ` }}
        </template>
         <template v-if="this.limitNum">
           限制数量:{{this.limitNum}}
        </template>
      </span>
      </div>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, type: 'checkbox', onSelect: onSelect}"
        :pagination="false"
        :customRow="loadCustomRow"
        :bordered="tableBordered">
        <template slot="picture" slot-scope="text, record">
          <div>
            <img v-if="record.picture" :src="record.picture"  style="width:40px;height:40px;" @click="handleRecordPreview(record.picture)" alt="none"/>
          </div>
        </template>
        <span slot="verOption" slot-scope="text, record">
          <custom-dict-tag :options="customDict.GoodsVerOptionEnum" :color="true" :value="record.verOption"/>
        </span>
        <span slot="goodsType" slot-scope="text, record">
          <custom-dict-tag :options="goodsTypeOption" :color="true" :value="record.goodsType"/>
        </span>
        <div slot="goodsCount" slot-scope="text, record">
          <a-input-number :max="limitNum" v-model="record.goodsCount"  placeholder="数量"  />
        </div>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </a-modal>
</template>

<script>
import { pageSpecArchive} from '@/api/goods/goodsArchive'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {listCategory} from "@/api/goods/category";
import Editor from "@/components/Editor/Editor";
import {tableMixin} from '@/store/table-mixin'


export default {
  name: 'GoodsSpecNumSelectForm',
  props: {},
  components: {
    Editor,
    CustomDictTag,
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      selectedRowKeys: [],
      selectedRows: [],
      emitStr: 'specNumSelect',
      categoryList: [],
      cateOptions: [],
      brandList: [],
      limitNum: undefined,
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      goodsTypeOption:[
        {"type":10,"name":"商品"},
        {"type":30,"name":"赠品"},
      ],
      levelOption:[
        {"type":2,"name":"2"},
        {"type":3,"name":"3"},
      ],
      open: false,
      loading: false,
      total: 0,
      index: null,
      specValueId: null,
      // 查询参数
      queryParam: {
        id: null,
        parentId: null,
        goodsBatchId: null,
        goodsType: undefined,
        goodsArchiveName: null,
        orderByGoodsIdList: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '规格编码',
          dataIndex: 'id',
          align: 'left',
        },
        {
          title: '规格名称',
          dataIndex: 'goodsArchiveName',
        },
        {
          title: '商品类型',
          dataIndex: 'goodsType',
          scopedSlots: {customRender: 'goodsType'},
        },
        {
          title: '售卖价格',
          dataIndex: 'salePrice',
        },
        {
          title: '数量',
          scopedSlots: {customRender: 'goodsCount'},
          dataIndex: 'goodsCount',
        },
        {
          title: '版本选项',
          dataIndex: 'verOption',
          scopedSlots: {customRender: 'verOption'},
          ellipsis: true,
          align: 'center'
        },
        {
          title: '图片',
          dataIndex: 'picture',
          scopedSlots: {customRender: 'picture'},
        },
      ]
    };
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict']),
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.open = false
      this.resetQueryForm()
    },
    reload() {
      this.selectedRowKeys = [];
      this.selectedRows=[];
    },
    /**
     *
     * @param records
     * @param goodsBatchId
     * @param goodsArchiveId
     * @param limitNum index
     * @param index index
     */
    openSpec(records, goodsBatchId,goodsArchiveId,limitNum, index) {
      console.log('传递了规格信息',records)
      this.queryParam.goodsBatchId = goodsBatchId
      if (limitNum) {
        this.limitNum= 1
      }
      this.index = index;
      if (records) {
        //深拷贝
        this.selectedRows = JSON.parse(JSON.stringify(records));
        this.selectedRowKeys = this.selectedRows.map(item => item.id);
        this.queryParam.orderByGoodsIdList = this.selectedRowKeys;
      }
      this.getList()
      this.open = true;
    },

    openSpecValue(records, goodsBatchId,goodsArchiveId,limitNum, specId, specValueId) {
      console.log('传递了规格信息',records)
      this.queryParam.goodsBatchId = goodsBatchId
      if (limitNum) {
        this.limitNum= limitNum
      }
      this.index = specId;
      this.specValueId = specValueId
      this.emitStr = 'specValueNumSelect'
      if (records) {
        //深拷贝
        this.selectedRows = JSON.parse(JSON.stringify(records));
        this.selectedRowKeys = this.selectedRows.map(item => item.id);
        this.queryParam.orderByGoodsIdList = this.selectedRowKeys;
      }
      this.getList()
      this.open = true;
    },
    onOk() {
      //判断有没有选择,拿到列表里选择的
      this.open = false
      //判断this.selectedRows 中的数量有没有值
      this.selectedRows.forEach(e => {
        if (!e.goodsCount) {
          this.$message.error('请输入数量')
        }
      });
      this.$emit(this.emitStr, this.selectedRows, this.index,this.specValueId);
      this.resetQueryForm()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.resetQueryForm()
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    /** 查询明星列表 */
    getList () {
      this.loading = true
      pageSpecArchive(this.queryParam).then(response => {
        this.list = response.data.records
        if (this.selectedRows && this.selectedRows.length > 0) {
          //回显出数量
          this.list.forEach(e=>{
            if (this.selectedRowKeys.includes(e.id)) {
              e.goodsCount =this.selectedRows.filter(g=>g.id===e.id)[0].goodsCount
            }
            if (e.children && e.children.length > 0) {
              e.children.forEach(child=>{
                if (this.selectedRowKeys.includes(child.id)) {
                  child.goodsCount =this.selectedRows.filter(g=>g.id===child.id)[0].goodsCount
                }
              })
            }
          })
        }
        this.total = response.data.total;
        this.loading = false
      })
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.resetQueryForm()
      this.handleQuery()
    },
    resetQueryForm() {
      this.selectedRowKeys= [];
      this.selectedRows= [];
      this.queryParam = {
        id: null,
        parentId: null,
        goodsBatchId: null,
        goodsType: undefined,
        goodsArchiveName: null,
        orderByGoodsIdList:undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.index = null
      this.specValueId = null
      this.emitStr = 'specNumSelect'
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelect (record, selected, selectedRows) {
      //如果是选中,则判断是限制数量
      if (selected) {
        if (this.selectedRows.length >= this.limitNum) {
          console.log('到达了限制数量,',1)
          return false
        }
        if (!record.goodsCount) {
          record.goodsCount=1
        }
        this.selectedRows.push(record);
      } else {
        this.selectedRows = this.selectedRows.filter(e => e.id !== record.id);
      }
      this.ids = this.selectedRows.map(item => item.id)
      this.selectedRowKeys = this.ids;
    },
    onSelectAll(selected, selectedRows, changeRows) {
      if (selected) {
        this.selectedRows =this.selectedRows.concat(changeRows)
      } else {
        let selectIds = changeRows.map(e => e.id);
        this.selectedRows = this.selectedRows.filter(e => !selectIds.includes(e.id));
      }
      this.ids = this.selectedRows.map(item => item.id)
      this.selectedRowKeys = this.ids;
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    loadCustomRow (record, index) {
      return {
        on: {
          click: (event) => {
            //判断是否有选择
            const target = event.target;
            if (target.tagName === 'INPUT') {
              // 如果点击的是输入框区域，不触发选中
              return;
            }
            //判断是否有选择
            if (this.selectedRowKeys.includes(record.id)) {
              //删除此id
              this.selectedRowKeys = this.selectedRowKeys.filter(e => e !== record.id)
              //删除此对象
              this.selectedRows = this.selectedRows.filter(e => e.id !== record.id)
            } else {
              this.onSelect(record, true, this.selectedRows)
            }
          },
        }
      }
    },
    getCategoryList() {
      listCategory().then(response => {
        this.categoryList = response.data
        let children = this.handleTree(response.data, 'id', 'pid')
        console.log('children', children)
        this.cateOptions = children
      })
    },
  }
}
</script>
